import styled from "styled-components"
import { Colors, Label_s } from 'styles/app-styles'

export const HoverPreview_s = styled.div`
  background-color: ${Colors.white};
  border: 1px solid ${Colors.blackPearl};
  border-radius: 4px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  color: ${Colors.blackPearl};
  font-size: 14px;
  margin: -5px -8px -8px -8px;

  ${Label_s}{
    font-size: 14px;
    font-weight: 500;
  }
`

export const HoverTitle_s = styled.div`
  background: ${Colors.inputFocus};
  height: 30px;
  line-height: 30px;
  padding: 0 8px;
  text-transform: capitalize;
`

export const SingleRow_s = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 0;
  div {
    display: flex;
    flex-direction: column;
    padding: 0 15px;
    text-align: left;
  }
`

export const MultipleRow_s = styled.div`
  padding-bottom: 10px;
  > table { 
    margin: 0 10px; 
    width: auto !important;
  }
  > table thead th label { margin-right: 10px; }
  > table tr { height: 25px; }
  > table td { padding: 0 !important; }
  > table tr td span { margin-right: 10px !important; }
  thead th { text-align: left; }
`

export const RentHover_s = styled.div`
  display: grid;
  grid-template-columns: 80px 420px;
  grid-template-areas:
  "....... content content"
  "sidebar content content"
  "sidebar content content";
  padding: 10px 10px 0 10px;
  text-align: left;
  > div:first-child {
    grid-area: sidebar;
    display: flex;
    flex-direction: column;
    padding-top: 20px;
  }
  > div:last-child {
    grid-area: content;
    display: flex;
    flex-direction: column;
    > div {
      display: flex;
      justify-content: space-between;
    }
    > div > div {
      margin-bottom: 10px;
    }
    > div > div, > div > ${Label_s} {
      width: 30%;
    }
  }
`

export const LineItemDetailedHover_s = styled.div`
  > div:first-child {
    display: flex;
    margin-left: auto;
    padding: 10px 15px 15px 10px;
    > div:first-child {
      margin-right: 10px;
    }
  }
  > div:nth-child(2) {
    display: flex;
    margin-left: 10px;
    ${Label_s} {
      text-align: left;
      width: 80px;
    }
  }
`

export const LineItemDetailed_s = styled.div`
  display: flex;
  padding: 0 10px 10px 10px;
  > div:first-child {
    display: flex;
    flex-direction: column;
    width: 80px;
    ${Label_s}{
      height: 20px;
      margin: 0;
    }
  }
  > div:last-child {
    display: flex;
    > div {
      display: flex;
      flex-direction: column;
      text-align: left;
      width: 80px;
      > div {
        display: flex;
        height: 20px;
      }
    }
  }
`

export const RecoveriesHover_s = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  > div { 
    display: flex; 
    margin-bottom: 5px;
  }
  > div > div {
    width: 150px;
  }
  > div > div:first-child {
    text-align: left;
  }
`
